import { ReactNode } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { CheckboxProps, Checkbox, FormControlLabel } from 'material-hu';

type Props = CheckboxProps & {
  label: ReactNode;
  rules?: any;
  error?: boolean;
};

function FormCheckbox({ label, name, rules, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <FormControlLabel
      control={
        <Controller
          rules={rules}
          render={({
            field: { ref, value, ...field },
            fieldState: { error },
          }) => (
            <Checkbox
              inputRef={ref}
              error={error ? 1 : 0}
              checked={!!value}
              sx={{
                p: '0 6px',
                pl: 0,
                alignSelf: 'flex-start',
              }}
              {...field}
              {...other}
            />
          )}
          name={name}
          control={control}
        />
      }
      label={label}
      sx={{ ml: 0 }}
    />
  );
}

export default FormCheckbox;
